<template>
  <div id="detalhes-edital">
    <b-overlay :show="loadEdital">
      <div class="d-flex justify-content-end mx-4 my-2">
        <span
          ><strong>{{ situacaoComputed }}</strong></span
        >
      </div>
      <b-card header-tag="header" class="m-3" no-body>
        <template #header>
          <header-sagres
            :titulo="tituloComputed"
            :botoes="botoesHeader"
            breakpoint="xl"
          />
        </template>
        <b-tabs card>
          <b-tab title="Dados Gerais">
            <AbaCadastroConcurso
              :idEdital="Number(idEdital)"
              :detalhes="true"
            />
          </b-tab>

          <b-tab title="Anexos">
            <AbaAnexoConcurso
              :idEdital="Number(idEdital)"
              :idTipoEdital="edital.IdTipoEdital"
              :contador="0"
              :detalhes="true"
            />
          </b-tab>

          <b-tab title="Cargos">
            <AbaCargosConcurso :idEdital="Number(idEdital)" :detalhes="true" />
          </b-tab>

          <b-tab
            title="Homologação"
            v-if="edital.IdSituacao === 4 || edital.IdSituacao === 2"
          >
            <AbaHomologarEdital
              :idEdital="Number(idEdital)"
              :idTipoEdital="edital.IdTipoEdital"
              :contador="0"
              :dataHomologacao="edital.DtHomologacao"
              :detalhes="true"
            />
          </b-tab>

          <b-tab title="Publicidade" v-if="edital.IdSituacao === 2">
            <AbaAtoPublicidade
              :idEdital="Number(idEdital)"
              :idTipoEdital="edital.IdTipoEdital"
              :contador="0"
              :detalhes="true"
            />
          </b-tab>

          <b-tab title="Classificados" v-if="edital.IdSituacao === 2">
            <AbaClassificadosConcurso
              :idEdital="Number(idEdital)"
              :detalhes="true"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-overlay>
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import { BotaoSagres } from "@/types/botao-sagres";
import { Component, Ref, Vue } from "vue-property-decorator";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import concursoService from "@/services/atos-pessoal/concursoService";
import { EditalConcurso } from "@/types/atos-pessoal/concursos/edital";
import AbaAnexoConcurso from "@/components/atos-pessoal/concursos/AbaAnexoConcurso.vue";
import AbaCargosConcurso from "@/components/atos-pessoal/concursos/AbaCargosConcurso.vue";
import AbaHomologarEdital from "@/components/atos-pessoal/concursos/AbaHomologarEdital.vue";
import AbaCadastroConcurso from "@/components/atos-pessoal/concursos/AbaCadastrarConcurso.vue";
import AbaClassificadosConcurso from "@/components/atos-pessoal/concursos/AbaClassificadosConcurso.vue";
import AbaAtoPublicidade from "@/components/atos-pessoal/concursos/AbaAtoPublicidade.vue";

const CompProps = Vue.extend({
  name: "DetalhesEdital",
  props: {
    idEdital: {
      type: String,
      required: true,
    },
  },
  components: {
    HeaderSagres,
    AbaAnexoConcurso,
    AbaCargosConcurso,
    AbaHomologarEdital,
    AbaCadastroConcurso,
    AbaClassificadosConcurso,
    AbaAtoPublicidade,
  },
});

@Component
export default class DetalhesEdital extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  botoesHeader: BotaoSagres[] = [
    {
      id: -1,
      icone: "arrow-left",
      texto: "Voltar",
    },
    {
      id: 1,
      icone: "pencil",
      texto: "Editar",
      url: `/atos-pessoal/concursos/editar-edital/${this.idEdital}/0`,
    },
  ];

  edital: any = new EditalConcurso();
  loadEdital = false;

  async mounted() {
    try {
      this.loadEdital = true;
      const response = await concursoService.getConcursoById(this.idEdital);
      if (!response) return this.$toast.error("Erro ao encontrar edital");
      this.edital = new EditalConcurso(response);
    } catch (error: any) {
      this.tratarError(error);
    } finally {
      this.loadEdital = false;
    }
  }

  get tituloComputed() {
    return `Detalhes do ${
      this.edital?.IdTipoEditalNavigation?.DsTipoEdital || "Edital"
    } ${this.edital.NrEdital}/${this.edital.AnoEdital}`;
  }

  get situacaoComputed() {
    switch (this.edital.IdSituacao) {
      case 1:
        return "Situação: Em Cadastramento";
      case 2:
        return "Situação: Homologado";
      case 3:
        return "Situação: Cancelado";
      case 4:
        return "Situação: Cadastrado";
      default:
        return "";
    }
  }
}
</script>